import React, { useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import type { FreeformEditableHabit } from "../types";
import LoaderButton from "../../user/components/LoaderButton";
import PromptList from "./PromptList";
import ExpandingTextInput from "../../common/ExpandingTextInput";
import VisibilityOption from "./VisibilityOption";
type Props = {
  onSave: (arg0: FreeformEditableHabit, arg1: boolean) => void;
  habit?: FreeformEditableHabit;
};
export default function FreeformHabitForm(props: Props) {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(props.habit ? props.habit.title : "");
  const [description, setDescription] = useState(
    props.habit ? props.habit.description : ""
  );
  const [prompts, setPrompts] = useState(
    props.habit ? props.habit.extras : [""]
  );
  const [visibility, setVisibility] = useState(
    props.habit ? props.habit.visibility : null
  );

  function validateForm() {
    return (
      title.length > 0 &&
      description.length > 0 &&
      prompts.length > 0 &&
      prompts.find((prompt) => !(prompt.length > 0)) === undefined
    );
  }

  function onSubmit() {
    setLoading(true);
    const habit: FreeformEditableHabit = {
      title,
      description,
      type: "freeform",
      extras: prompts,
      visibility,
    };
    props.onSave(habit, props.habit == null);
  }

  return (
    <View style={styles.container}>
      <View style={styles.hContainer}>
        <Text style={styles.explanation}>
          Fill out the details of your habit below
        </Text>
        <LoaderButton
          label="Save"
          disabled={!validateForm()}
          loading={loading}
          onPress={onSubmit}
        />
      </View>
      <Text style={styles.labelTexts}>Title</Text>
      <ExpandingTextInput
        value={title}
        placeholder="Title"
        style={styles.titleInput}
        onChangeText={(text) => setTitle(text)}
      />
      <Text style={styles.labelTexts}>Description</Text>
      <ExpandingTextInput
        value={description}
        multiline={true}
        numberOfLines={2}
        maxLength={165}
        placeholder="Description"
        style={styles.descriptionInput}
        onChangeText={(text) => setDescription(text)}
      />
      <VisibilityOption visibility={visibility} onChange={setVisibility} />
      <Text style={styles.labelTexts}>Prompts:</Text>
      <PromptList prompts={prompts} onChangePrompts={setPrompts} />
    </View>
  );
}
const inputStyles = {
  padding: 7,
  margin: 5,
  borderWidth: 1,
  borderRadius: 3,
  borderColor: "black",
  width: "100%",
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "stretch",
    alignSelf: "center",
    maxWidth: 600,
    width: "100%",
  },
  labelTexts: {
    marginTop: 8,
    marginBottom: 0,
    marginLeft: 5,
    marginRight: 5,
  },
  titleInput: { ...inputStyles, padding: 7, fontSize: 20 },
  descriptionInput: { ...inputStyles, padding: 7, fontSize: 14 },
  promptInput: { ...inputStyles, padding: 7, fontSize: 14 },
  hContainer: {
    flexDirection: "row",
  },
  explanation: {
    paddingLeft: 5,
    paddingTop: 15,
    flex: 1,
  },
});
